/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { VirtualElement } from "../components/core";
import { getBoundingClientRect } from "./getBoundingClientRect";
import { getElementScroll } from "./getElementScroll";
import { isHTMLElement } from "@adapptio/lib-shared";

export interface Rect {
	width: number;
	height: number;
	x: number;
	y: number;
}

export function getRelativeRect(
	elementOrVirtualElement: Element | VirtualElement,
	offsetParent: Element | Window
): Rect {
	const rect = getBoundingClientRect(elementOrVirtualElement);
	const scroll = getElementScroll(offsetParent);

	const offsets = { x: 0, y: 0 };

	if (isHTMLElement(offsetParent)) {
		const parentRect = getBoundingClientRect(offsetParent);
		offsets.x = parentRect.x;
		offsets.y = parentRect.y;
		offsets.x += offsetParent.clientLeft;
		offsets.y += offsetParent.clientTop;
	}

	return {
		x: rect.left + scroll.scrollLeft - offsets.x,
		y: rect.top + scroll.scrollTop - offsets.y,
		width: rect.width,
		height: rect.height
	};
}
